export class editRequest {
    alt_email: string;
    branch_id: number;
    branch_nm: string;
    college_name: string;
    college_name_id: number;
    doc_id: number;
    doc_name: string;
    enroll_no: string;
    first_name: string;
    id: number;
    last_name: string;
    monthOfPassing: string;
    request_type_id: number;
    semester: string;
    semid: number;
    stream_id: number;
    stream_name: string;
   upload_doc_path: any;
    year: any;
    year_of_pass_id: number;
    embassyname : string;
    embassyaddress : string;
    embassyid : number;
}